import { useState } from 'react';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function FlightDeals() {
  const [activeTab, setActiveTab] = useState('domestic');

  const domesticDeals = [
    {
      route: 'Delhi to Mumbai',
      airline: 'Premium Airline',
      price: '₹3,499',
      originalPrice: '₹5,999',
      discount: '42% OFF',
      duration: '2h 15m',
      stops: 'Non-stop',
      image: 'https://readdy.ai/api/search-image?query=modern%20white%20commercial%20airplane%20flying%20through%20blue%20sky%20with%20fluffy%20white%20clouds%2C%20Indian%20domestic%20aviation%2C%20premium%20airline%20aircraft%20soaring%20gracefully%2C%20professional%20aviation%20photography%20with%20golden%20lighting%2C%20clean%20aircraft%20design%20against%20beautiful%20sky%20background&width=400&height=300&seq=flight-deal-1&orientation=landscape'
    },
    {
      route: 'Bangalore to Chennai',
      airline: 'National Carrier',
      price: '₹2,899',
      originalPrice: '₹4,500',
      discount: '36% OFF',
      duration: '1h 25m',
      stops: 'Non-stop',
      image: 'https://readdy.ai/api/search-image?query=sleek%20blue%20and%20white%20commercial%20aircraft%20on%20airport%20runway%2C%20modern%20Indian%20aviation%20terminal%20building%20in%20background%2C%20clear%20sunny%20day%2C%20professional%20aircraft%20photography%2C%20domestic%20airline%20service%20with%20beautiful%20sky&width=400&height=300&seq=flight-deal-2&orientation=landscape'
    },
    {
      route: 'Mumbai to Goa',
      airline: 'Budget Airways',
      price: '₹2,199',
      originalPrice: '₹3,800',
      discount: '42% OFF',
      duration: '1h 30m',
      stops: 'Non-stop',
      image: 'https://readdy.ai/api/search-image?query=colorful%20red%20and%20white%20passenger%20aircraft%20taking%20off%20from%20coastal%20airport%20runway%2C%20tropical%20beach%20destination%20visible%20in%20background%2C%20beautiful%20ocean%20view%2C%20professional%20aviation%20photography%20for%20vacation%20travel&width=400&height=300&seq=flight-deal-3&orientation=landscape'
    },
    {
      route: 'Kolkata to Hyderabad',
      airline: 'Express Airlines',
      price: '₹4,299',
      originalPrice: '₹6,999',
      discount: '39% OFF',
      duration: '2h 10m',
      stops: 'Non-stop',
      image: 'https://readdy.ai/api/search-image?query=elegant%20purple%20and%20silver%20modern%20passenger%20jet%20flying%20above%20Indian%20metropolitan%20cityscape%2C%20urban%20landscape%20below%2C%20premium%20airline%20aircraft%2C%20professional%20aviation%20photography%20with%20city%20lights%20and%20modern%20architecture&width=400&height=300&seq=flight-deal-4&orientation=landscape'
    }
  ];

  const internationalDeals = [
    {
      route: 'Delhi to Dubai',
      airline: 'Middle East Airlines',
      price: '₹18,999',
      originalPrice: '₹28,500',
      discount: '33% OFF',
      duration: '3h 20m',
      stops: 'Non-stop',
      image: 'https://readdy.ai/api/search-image?query=luxurious%20white%20and%20gold%20commercial%20aircraft%20flying%20over%20Dubai%20skyline%20with%20iconic%20Burj%20Khalifa%20and%20modern%20skyscrapers%2C%20international%20flight%20route%2C%20Middle%20East%20destination%2C%20golden%20sunset%20lighting%20over%20futuristic%20city&width=400&height=300&seq=flight-intl-1&orientation=landscape'
    },
    {
      route: 'Mumbai to London',
      airline: 'European Carrier',
      price: '₹45,999',
      originalPrice: '₹68,000',
      discount: '32% OFF',
      duration: '9h 30m',
      stops: 'Non-stop',
      image: 'https://readdy.ai/api/search-image?query=majestic%20international%20aircraft%20flying%20over%20London%20with%20Thames%20river%20and%20Big%20Ben%20visible%20below%2C%20long-haul%20flight%20to%20European%20destination%2C%20cloudy%20British%20sky%20background%2C%20premium%20airline%20service%20photography&width=400&height=300&seq=flight-intl-2&orientation=landscape'
    },
    {
      route: 'Bangalore to Singapore',
      airline: 'Asian Airways',
      price: '₹22,999',
      originalPrice: '₹34,500',
      discount: '33% OFF',
      duration: '4h 15m',
      stops: 'Non-stop',
      image: 'https://readdy.ai/api/search-image?query=modern%20commercial%20aircraft%20approaching%20Singapore%20with%20Marina%20Bay%20Sands%20and%20futuristic%20city%20skyline%20in%20background%2C%20Southeast%20Asian%20destination%2C%20tropical%20urban%20setting%2C%20professional%20aviation%20photography&width=400&height=300&seq=flight-intl-3&orientation=landscape'
    },
    {
      route: 'Chennai to Kuala Lumpur',
      airline: 'Southeast Carrier',
      price: '₹16,499',
      originalPrice: '₹24,800',
      discount: '33% OFF',
      duration: '3h 45m',
      stops: 'Non-stop',
      image: 'https://readdy.ai/api/search-image?query=commercial%20aircraft%20flying%20over%20Kuala%20Lumpur%20with%20iconic%20Petronas%20Twin%20Towers%20visible%2C%20Southeast%20Asian%20international%20route%2C%20modern%20Malaysian%20city%20destination%2C%20tropical%20landscape%20with%20urban%20skyline&width=400&height=300&seq=flight-intl-4&orientation=landscape'
    }
  ];

  const currentDeals = activeTab === 'domestic' ? domesticDeals : internationalDeals;

  const handleCallNow = () => {
    window.open('tel:+919700644857', '_self');
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-orange-100 text-orange-800 rounded-full text-sm font-semibold mb-4">
            <i className="ri-fire-line mr-2"></i>
            Limited Time Offers
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Exclusive Flight Deals
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Grab these incredible flight deals before they're gone! We guarantee the lowest prices on all domestic and international routes with instant booking confirmation.
          </p>

          <div className="flex justify-center">
            <div className="bg-white p-2 rounded-full shadow-lg">
              <button
                onClick={() => setActiveTab('domestic')}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  activeTab === 'domestic'
                    ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg'
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                <i className="ri-flight-takeoff-line mr-2"></i>
                Domestic Flights
              </button>
              <button
                onClick={() => setActiveTab('international')}
                className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  activeTab === 'international'
                    ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg'
                    : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                <i className="ri-flight-land-line mr-2"></i>
                International Flights
              </button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {currentDeals.map((deal, index) => (
            <Card key={index} hover className="overflow-hidden bg-white">
              <div className="relative">
                <img
                  src={deal.image}
                  alt={deal.route}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-3 right-3 bg-gradient-to-r from-orange-500 to-red-500 text-white px-3 py-1 rounded-full text-xs font-bold">
                  {deal.discount}
                </div>
                <div className="absolute bottom-3 left-3 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                  <span className="text-xs font-semibold text-gray-800">{deal.airline}</span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-2">{deal.route}</h3>
                
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center text-sm text-gray-600">
                    <i className="ri-time-line mr-1"></i>
                    {deal.duration}
                  </div>
                  <div className="flex items-center text-sm text-green-600">
                    <i className="ri-check-circle-line mr-1"></i>
                    {deal.stops}
                  </div>
                </div>

                <div className="flex items-center justify-between mb-4">
                  <div>
                    <div className="text-2xl font-bold text-blue-600">{deal.price}</div>
                    <div className="text-sm text-gray-500 line-through">{deal.originalPrice}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-xs text-gray-500">per person</div>
                    <div className="text-xs text-orange-600 font-semibold">Save {deal.discount}</div>
                  </div>
                </div>

                <Button className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700">
                  <i className="ri-plane-line mr-2"></i>
                  Book Now
                </Button>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-white rounded-2xl p-8 shadow-lg max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                  <i className="ri-price-tag-3-line text-2xl text-green-600"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">Lowest Price Guarantee</h4>
                <p className="text-sm text-gray-600">Find a lower price? We'll match it plus give you ₹500 extra!</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-4">
                  <i className="ri-flashlight-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">Instant Confirmation</h4>
                <p className="text-sm text-gray-600">Get your e-tickets immediately after booking confirmation</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-purple-100 rounded-full mx-auto mb-4">
                  <i className="ri-customer-service-2-line text-2xl text-purple-600"></i>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">24/7 Support</h4>
                <p className="text-sm text-gray-600">Round-the-clock assistance for all your travel needs</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}